<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        Total
        <DoughnutChart v-if="!loading" chartId="total" :count="summary.total" color="#00B695"/>
      </b-col>
      <b-col>
        <span @click="load" style="cursor: pointer;">Background Task</span>
        <div class="spinner-border spinner-border-sm cursor-pointer ml-2" role="status" v-if="summary.batch">
          <span class="sr-only">Loading...</span>
        </div>
        <span class="spinner"></span>
        <DoughnutChart v-if="!loading" chartId="batch" :count="summary.batch" color="#FFDB58"/>
      </b-col>
      <b-col>
        Normal
        <DoughnutChart v-if="!loading" chartId="normal" :count="summary.normal.total" color="#000080"/>
      </b-col>
      <b-col>
        Webshell
        <DoughnutChart v-if="!loading" chartId="done" :count="summary.webshell.total" color="#F5DEB3"/>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col>
        <table class="w-100 table text-center">
          <thead>
            <th class="m-2 p-2" colspan="2"></th>
            <th class="m-2 p-2">asp</th>
            <th class="m-2 p-2">jsp</th>
            <th class="m-2 p-2">perl</th>
            <th class="m-2 p-2">php</th>
            <th class="m-2 p-2">python</th>
            <th class="m-2 p-2">ruby</th>
            <th class="m-2 p-2">javascript</th>
            <th class="m-2 p-2">java</th>
            <th class="m-2 p-2">etc</th>
            <th class="m-2 p-2">Total</th>
          </thead>
          <tbody>
            <tr>
              <td rowspan="3" style="vertical-align: middle;">Webshell</td>
            </tr>
            <tr class="text-danger font-weight-bold">
              <td>Total</td>
              <td> {{ summary.webshell.asp | number }} </td>
              <td> {{ summary.webshell.jsp | number }} </td>
              <td> {{ summary.webshell.perl | number }} </td>
              <td> {{ summary.webshell.php | number }} </td>
              <td> {{ summary.webshell.python | number }} </td>
              <td> {{ summary.webshell.ruby | number }} </td>
              <td> {{ summary.webshell.javascript | number }} </td>
              <td> {{ summary.webshell.java | number }} </td>
              <td> {{ summary.webshell.etc | number }} </td>
              <td> {{ summary.webshell.total | number }} </td>
            </tr>
            <tr>
              <td>%</td>
              <td> {{ percent('webshell', summary.webshell.asp) }} </td>
              <td> {{ percent('webshell', summary.webshell.jsp) }} </td>
              <td> {{ percent('webshell', summary.webshell.perl) }} </td>
              <td> {{ percent('webshell', summary.webshell.php) }} </td>
              <td> {{ percent('webshell', summary.webshell.python) }} </td>
              <td> {{ percent('webshell', summary.webshell.ruby) }} </td>
              <td> {{ percent('webshell', summary.webshell.javascript) }} </td>
              <td> {{ percent('webshell', summary.webshell.java) }} </td>
              <td> {{ percent('webshell', summary.webshell.etc) }} </td>
              <td> - </td>

            </tr>

            <tr>
              <td rowspan="3" style="vertical-align: middle;">Normal</td>
            </tr>
            <tr class="text-primary font-weight-bold">
              <td>Total</td>
              <td> {{ summary.normal.asp | number }} </td>
              <td> {{ summary.normal.jsp | number }} </td>
              <td> {{ summary.normal.perl | number }} </td>
              <td> {{ summary.normal.php | number }} </td>
              <td> {{ summary.normal.python | number }} </td>
              <td> {{ summary.normal.ruby | number }} </td>
              <td> {{ summary.normal.javascript | number }} </td>
              <td> {{ summary.normal.java | number }} </td>
              <td> {{ summary.normal.etc | number }} </td>
              <td> {{ summary.normal.total | number }} </td>
            </tr>
            <tr>
              <td>%</td>
              <td> {{ percent('normal', summary.normal.asp) }} </td>
              <td> {{ percent('normal', summary.normal.jsp) }} </td>
              <td> {{ percent('normal', summary.normal.perl) }} </td>
              <td> {{ percent('normal', summary.normal.php) }} </td>
              <td> {{ percent('normal', summary.normal.python) }} </td>
              <td> {{ percent('normal', summary.normal.ruby) }} </td>
              <td> {{ percent('normal', summary.normal.javascript) }} </td>
              <td> {{ percent('normal', summary.normal.java) }} </td>
              <td> {{ percent('normal', summary.normal.etc) }} </td>
              <td> - </td>
            </tr>

            <!-- total -->

            <tr class="text-success font-weight-bold">
              <td style="vertical-align: middle;" colspan="2">Total</td>
              <td> {{ (summary.webshell.asp + summary.normal.asp) | number }} </td>
              <td> {{ (summary.webshell.jsp + summary.normal.jsp) | number }} </td>
              <td> {{ (summary.webshell.perl + summary.normal.perl) | number }} </td>
              <td> {{ (summary.webshell.php + summary.normal.php) | number }} </td>
              <td> {{ (summary.webshell.python + summary.normal.python) | number }} </td>
              <td> {{ (summary.webshell.ruby + summary.normal.ruby) | number }} </td>
              <td> {{ (summary.webshell.javascript + summary.normal.javascript) | number }} </td>
              <td> {{ (summary.webshell.java + summary.normal.java) | number }} </td>
              <td> {{ (summary.webshell.etc + summary.normal.etc) | number }} </td>
              <td> {{ (summary.webshell.total + summary.normal.total) | number }} </td>
            </tr>

            <tr class="">
              <td style="vertical-align: middle;" colspan="2">%</td>
              <td> {{ percent('', summary.webshell.asp + summary.normal.asp) }} </td>
              <td> {{ percent('', summary.webshell.jsp + summary.normal.jsp) }} </td>
              <td> {{ percent('', summary.webshell.perl + summary.normal.perl) }} </td>
              <td> {{ percent('', summary.webshell.php + summary.normal.php) }} </td>
              <td> {{ percent('', summary.webshell.python + summary.normal.python) }} </td>
              <td> {{ percent('', summary.webshell.ruby + summary.normal.ruby) }} </td>
              <td> {{ percent('', summary.webshell.javascript + summary.normal.javascript) }} </td>
              <td> {{ percent('', summary.webshell.java + summary.normal.java) }} </td>
              <td> {{ percent('', summary.webshell.etc + summary.normal.etc) }} </td>
              <td> {{ percent('', summary.webshell.total + summary.normal.total) }} </td>
            </tr>

          </tbody>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import vSelect from 'vue-select';
// import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
// import datepicker from '@/f1/custom';
import { api, auth } from '@/f1/service';
import 'vue2-datepicker/index.css';
// import config from '@/f1/config'
import moment from 'moment-timezone';
import _ from 'lodash';

// component
import DoughnutChart from '@/f1/views/dashboard/components/DoughnutChart.vue'

const default_opt = () => ({
  perPage: 25,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt: {
    created_at_ed: moment().add(1, 'd'),
    created_at_sd: moment().add(1, 'd'),
  }, adv: false,
  pageoptions: [
    { text: '10 rows', value: 10 },
    { text: '25 rows', value: 25 },
    { text: '50 rows', value: 50 },
    { text: '100 rows', value: 100 },
    { text: '200 rows', value: 200 }
  ]
});

export default {
  components: { DatePicker, DoughnutChart },
  data: () => ({
    th : undefined,
    loading: false,
    summary : { normal: 0, total: 0, done: 0, batch: 0, webshell : 0 },
    so: default_opt(),
    profile: auth.profile
  }),
  computed: {
  },
  methods: {
    percent(type='normal', x = 0) {

      if(!x) { return 0; }

      if(type == 'normal') {
        return this.summary.normal.total === 0 ? 0 : (x / this.summary.normal.total * 100).toFixed(2)
      } else if (type == 'webshell') {
        return this.summary.webshell.total === 0 ? 0 : (x / this.summary.webshell.total * 100).toFixed(2)
      } else {
        return (this.summary.webshell.total + this.summary.webshell.normal) === 0 ? 0 : (x / (this.summary.webshell.total + this.summary.normal.total) * 100).toFixed(1)
      }

    },
    async load() {
      this.loading = true;
      try {
        let rs = await api.dms.upload.summary();

        this.summary = Object.assign({}, this.summary, rs)

        this.summary.webshell.total = _.sum(_.values(this.summary.webshell));
        this.summary.normal.total = _.sum(_.values(this.summary.normal));
        this.summary.total = this.summary.webshell.total + this.summary.normal.total;

        clearInterval(this.th)
        this.th = setInterval(() => this.load(), 30 * 1000);

      } catch (e) { this.$toastr.e(e.data || e); }
      finally {
        this.loading = false;
      }
    },
  },
  created() { },
  destroyed() { clearInterval(this.th) },
  mounted() { this.load() },
}
</script>
<style>

.spinner {
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>

